/**
 * @param email {string}
 * @return {void}
 */
module.exports = function identifyInHeap(email) {
    if ("heap" in window) {
        try {
            window.heap.identify(email);
        } catch (e) {
            console.error("Heap did not work!");
        }
    }
}